import { environment } from '../../environments/environment';

export const URLS = Object({
	//Authentication
	'login': `${environment.apiUrl}/login`,
	'signup': `${environment.apiUrl}/register`,
	'forgotPassword': `${environment.apiUrl}/forgot-password`,
	'resetPassword': `${environment.apiUrl}/reset-password`,
	'changePassword': `${environment.apiUrl}/change-password`,
	'emailVerification': `${environment.apiUrl}/send-verification-mail`,
	'verifyEmail': `${environment.apiUrl}/verify-email`,
	'logout': `${environment.apiUrl}/logout`,

	//Home
	'getVideo': `${environment.apiUrl}/home/video/get`,
	'updateVideo': `${environment.apiUrl}/home/video/count`,
	'getValidToken': `${environment.apiUrl}/user/isValidToken`,
	'getHomePageFormData': `${environment.apiUrl}/home/forms/get`,
	'getArticle': `${environment.apiUrl}/home/article/get`,

	//Profile
	'getProfile': `${environment.apiUrl}/profile/get`,
	'updateProfile': `${environment.apiUrl}/profile/update`,
	'favCharityList': `${environment.apiUrl}/user/profile/fav-charity/list`,
	'addFavCharity': `${environment.apiUrl}/user/profile/fav-charity/add`,
	'updateFavCharity': `${environment.apiUrl}/user/profile/fav-charity/update`,
	'deleteFavCharity': `${environment.apiUrl}/user/profile/fav-charity/delete`,

	//Address
	'saveAddress': `${environment.apiUrl}/address/add`,
	'getAddress': `${environment.apiUrl}/address/get`,
	'updateAddress': `${environment.apiUrl}/address/update`,
	'deleteAddress': `${environment.apiUrl}/address/delete`,

	//CMS
	'getPrivacy': `${environment.apiUrl}/home/cms/getById`,
	'getTerms': `${environment.apiUrl}/home/cms/getById`,
	'getFaq': `${environment.apiUrl}/home/faq/get`,
	'acceptTerms': `${environment.apiUrl}/my-org/charity/accept-nonprofit-tnc`,

	//Contact us
	'saveContactUs': `${environment.apiUrl}/home/contact/add`,

	//My files
	// 'getWillFiles': `${environment.apiUrl}/files/get`,
	// 'getFuneralFiles': `${environment.apiUrl}/files/get`,
	// 'getHealthFiles': `${environment.apiUrl}/files/get`,
	'getFormFiles': `${environment.apiUrl}/files/get`,
	'deleteFile': `${environment.apiUrl}/files/delete`,
	'downloadFile': `${environment.apiUrl}/files/download`,
	'sharedFile': `${environment.apiUrl}/files/share-pdf`,
	'getSharedWith': `${environment.apiUrl}/files/shared-with`,
	'fileUpload': `${environment.apiUrl}/files/convert/upload`,
	'sharedMe': `${environment.apiUrl}/files/shared-me`,
	'sharedDelete': `${environment.apiUrl}/files/shared-me/delete`,
	'signedFileUpload': `${environment.apiUrl}/files/upload`,
	'emailDocMe': `${environment.apiUrl}/files/email/me`,

	// Form builder
	'getFormList': `${environment.apiUrl}/form/list`,
	'getFilledFormDetails': `${environment.apiUrl}/form/getfilledformdetail`,
	'formSaveAnswer': `${environment.apiUrl}/form/saveanswer`,
	'formSaveProgress': `${environment.apiUrl}/form/saveProgressIndex`,
	'formUpdateStatus': `${environment.apiUrl}/form/update-status`,
	'getPdfData': `${environment.apiUrl}/pdf/getdata`,
	'saveDonation': `${environment.apiUrl}/form/donate/save`,

	'genratePdf': `${environment.apiUrl}/files/generate-pdf`,

	'deleteFormData': `${environment.apiUrl}/form/data/delete`,
	//Funeral Audio
	'getSongTypeList': `${environment.apiUrl}/form/audio/category`,
	'getSongList': `${environment.apiUrl}/form/audio/list`,

	// Notification
	'getNotificationList': `${environment.apiUrl}/user/notification/get`,
	'getNotificationCount': `${environment.apiUrl}/user/notification/count`,
	'notificationStatus': `${environment.apiUrl}/user/notification/update-status`,

	//
	'getDonationCount': `${environment.apiUrl}/form/donate/counts`,
	//Testimonail
	'getTestimonail': `${environment.apiUrl}/home/testimonial/get`,
	'getHomeTestimonail': `${environment.apiUrl}/home/testimonial`,

	//Stripe Payment
	'amountSubmit': `${environment.apiUrl}/user/payment/create-checkout-session`,
	'paymentConfirmation': `${environment.apiUrl}/user/payment/session-status`,
	'cancelSession': `${environment.apiUrl}/user/payment/session/expire`,

	//sitemap
	'siteMapList': `${environment.apiUrl}/sitemap/list`,
	'siteMapDetail': `${environment.apiUrl}/sitemap/details`,

	//survey Form
	'surveyForm': `${environment.apiUrl}/survey`,
	//articles
	'articleCategory': `${environment.apiUrl}/home/article/category`,
	'articleDetail': `${environment.apiUrl}/home/article/detail`,

	//My Organization
	//Common
	'getCategory': `${environment.apiUrl}/my-org/charity/category`,
    'getCharities' : `${environment.apiUrl}/form/charity/list`,
    'emailSubscription': `${environment.apiUrl}/user/email-subscription`,
	'getOrgId':  `${environment.apiUrl}/my-org/profile/org-id-by-url`,

	// Promotion
	'getPromotionCategory': `${environment.apiUrl}/my-org/promotion/category`,
	'getPromotionList': `${environment.apiUrl}/my-org/promotion/list`,
	'downloadPromotion': `${environment.apiUrl}/my-org/promotion/download`,
	'sharePromotion': `${environment.apiUrl}/my-org/promotion/share-file`,

	// My Charities
	'getcharityList': `${environment.apiUrl}/my-org/charity/list`,
	'getcharityDetails': `${environment.apiUrl}/my-org/charity/getById`,
	'getcharityCategory': `${environment.apiUrl}/my-org/charity/category`,
	'favCharitySearch': `${environment.apiUrl}/user/profile/fav-charity/search`,


	// Employees
	'getemployeeList': `${environment.apiUrl}/my-org/users/team-members`,
	'updateEmployeeStatus': `${environment.apiUrl}/my-org/users/team-member/status`,
	'addEmployee': `${environment.apiUrl}/my-org/users/team-member/add`,
	'editEmployee': `${environment.apiUrl}/my-org/users/team-member/update`,

	// sponsorship
	'getSponsorshipList': `${environment.apiUrl}/my-org/users/sponsorship/list`,
	'getSponsorshipDetails': `${environment.apiUrl}/my-org/users/sponsorship/getById`,
	'getTransactionList': `${environment.apiUrl}/my-org/users/sponsorship/transaction/list`,
	'createSubscription': `${environment.apiUrl}/my-org/users/sponsorship/subscription/create-checkout-session`,
	'cancelSubscription': `${environment.apiUrl}/my-org/users/sponsorship/cancel-subscription`,
	'contactAdmin': `${environment.apiUrl}/my-org/users/sponsorship/contact-admin`,
	'subScriptionUpgradePreview': `${environment.apiUrl}/my-org/users/sponsorship/subscription/preview`,

	// Profile
	'getlandingpageDetail': `${environment.apiUrl}/my-org/profile/landing-page-configurations`,
	'getlandingpageData': `${environment.apiUrl}/my-org/profile/landing-page-data`,
	'imageUpload': `${environment.apiUrl}/file/upload`,
	'updateProfileDetail': `${environment.apiUrl}/my-org/profile/basic-details`,
	'updateBranding': `${environment.apiUrl}/my-org/profile/branding`,
	'urlCheck': `${environment.apiUrl}/my-org/profile/check-url-availability`,
	'updateUrlSetup': `${environment.apiUrl}/my-org/profile/general`,
	'updateAbout': `${environment.apiUrl}/my-org/profile/aboutUs`,
	'updateSupportMission': `${environment.apiUrl}/my-org/profile/supportOurMission`,
	'signUpLandingPage': `${environment.apiUrl}/my-org/profile/signupForm`,
	'updetekeyInitiatives': `${environment.apiUrl}/my-org/profile/keyInitiatives`,
	'updateAllSections': `${environment.apiUrl}/my-org/profile/all`,
	'getlandingpageTemplate': `${environment.apiUrl}/my-org/profile/landing-page-template-sample`,
	'updetekeyStatistics': `${environment.apiUrl}/my-org/profile/statistics`,
	'updeteTestimonial': `${environment.apiUrl}/my-org/profile/testimonials`,

	//Non-profit
	'connectWithUs': `${environment.apiUrl}/non-profit/inquiry`,


	//Dashboard section
	'dashboardSection': `${environment.apiUrl}/my-org/dashboard/donation-graph`,
	'donorSection': `${environment.apiUrl}/my-org/dashboard/donors-graph`,


	// Donar
	'donorList': `${environment.apiUrl}/my-org/dashboard/donor/list`,
	'dashboardOrganizations': `${environment.apiUrl}/my-org/dashboard/organizations`,

    //org
    'getCharityDetails': `${environment.apiUrl}/form/organization/details`,

    //orgdetails
    'getAllCharities': `${environment.apiUrl}/form/organization/bequest-section`,

	//urls
	'landingPageurl': `${environment.apiUrl}/my-org/profile/landingPage`,
	'deleteUsers': `${environment.apiUrl}/my-org/team-member/delete`,
	'zipDownload': `${environment.apiUrl}/my-org/share-promotion/download`,
	'shareUrl': `${environment.apiUrl}/my-org/profile/share-url`,
	'getFormOverview': `${environment.apiUrl}/my-org/dashboard/forms-overview`,
	'verfiyAllTier': `${environment.apiUrl}/my-org/dashboard/charity-tiers`,

	'getPresetImages': `${environment.apiUrl}/my-org/profile/stock-images`,

	'validateEmail': `${environment.apiUrl}/my-org/profile/primary-admin/email`,
	'postNewEmail': `${environment.apiUrl}/my-org/profile/primary-admin/send-email-verification`,
	'cancelVerifyEmail': `${environment.apiUrl}/my-org/profile/primary-admin/cancel-email-update`,
	'adminEmailVerification': `${environment.apiUrl}/my-org/profile/primary-admin/email-verification-url`

});

export const SECRET_KEY: string = '$2a$10$e.oPc.dyrwRoQCpDvO9Rhe';
